import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=1c22a5b6&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c22a5b6', component.options)
    } else {
      api.reload('1c22a5b6', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=1c22a5b6&", function () {
      api.rerender('1c22a5b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/SearchBar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/SearchBar.vue
// module id = mRSY
// module chunks = 0